(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {

    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection === null) {
      return; 
    }

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();

    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
                                                        
        $('.slick-product').slick({
          lazyLoad: 'ondemand',
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          prevArrow: '<button class="product-recom-prev"><svg xmlns="http://www.w3.org/2000/svg" width="34.391" height="21.228" viewBox="0 0 34.391 21.228"><defs><style>.a{fill:none;stroke:#bababa;stroke-width:2px;}</style></defs><g transform="translate(0.707 0.707)"><line class="a" x2="33.684" transform="translate(0 9.907)"></line><line class="a" y1="9.907" x2="9.907"></line><line class="a" x2="9.907" y2="9.907" transform="translate(0 9.907)"></line></g></svg></button>',
          nextArrow: '<button class="product-recom-next"><svg xmlns="http://www.w3.org/2000/svg" width="34.391" height="22.552" viewBox="0 0 36.642 22.552"><defs><style>.a{fill:none;stroke:#000;stroke-width:2px;}</style></defs><g transform="translate(35.935 21.845) rotate(180)"><line class="a" x2="35.935" transform="translate(0 10.569)"></line><line class="a" y1="10.569" x2="10.569"></line><line class="a" x2="10.569" y2="10.569" transform="translate(0 10.569)"></line></g></svg></button>',
          responsive: [
           {
             breakpoint: 650,
             settings: {
               slidesToShow: 1
             }
           },
           {
             breakpoint: 1024,
             settings: {
               slidesToShow: 2
             }
           },
           {
             breakpoint: 1300,
             settings: {
               slidesToShow: 3
             }
           }
         ]
        });
      }
    };
                                                        
    request.send();
  };

  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
                                                        
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();
 
  } catch(e) { console.error(e); }
})();
      })();
